import { createAsyncThunk } from '@reduxjs/toolkit';

import { SHOPIFY_CHANNEL_TYPE } from '../../components/teammates/views/Channels/helpers/salesChannelState';

export const saveSalesChannelName = createAsyncThunk(
  'salesChannels/saveSalesChannelName',
  async ({ name, salesChannelId }, { extra: { sdk, Logger } }) => {
    try {
      const payload = {
        type: SHOPIFY_CHANNEL_TYPE,
        name,
      };

      if (salesChannelId) {
        payload.salesChannelId = salesChannelId;
      }

      const { data } = await sdk.setup.saveSalesChannel(payload);
      return data;
    } catch (error) {
      Logger.error(
        new Error('Save sales channel name failed'),
        { error, salesChannelId },
        ['ConnectShopifyChSaveNameFailed', { salesChannelId: salesChannelId ? String(salesChannelId) : '' }],
      );
      throw error;
    }
  },
);
